/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Vector3fPb } from "../../../../gen/eigen_lcm/Vector3f";

export const protobufPackage = "skills";

/**
 * General settings of the movement API that are applicable in all actions.
 * See vehicle/planner/lcmtypes/movement.lcm for the full list of movement settings
 * Deprecated after switching to Motion API
 */
export interface MovementApiSettings {
  maxSpeed: number;
  maxHeadingRate: number;
  maxGimbalPitchRate: number;
  overridePrecisionFlight: boolean;
}

/** Deprecated */
export interface AtvSubjectSpoofActionArgs {
  numLoops: number;
  accel: number;
  decel: number;
  minSpeed: number;
  maxSpeed: number;
  length: number;
  width: number;
  radius: number;
  altitudeOffset: number;
  forward: boolean;
  reverse: boolean;
}

/** Deprecated */
export interface SkiSubjectSpoofActionArgs {
  length: number;
  numberOfTurns: number;
  width: number;
  slopeAngle: number;
  minSpeed: number;
  maxSpeed: number;
  altitudeOffset: number;
}

/** Deprecated */
export interface PrecomputedSubjectSpoofActionArgs {
  /** Number of loops to spoof the trajectory for. */
  numLoops: number;
  /**
   * Subject trajectory waypoints relative to vehicle pose. The subject pose in between times will
   * be interpolated.
   * Array of times at each subject waypoint.
   */
  times: number[];
  /** Array of positions at each subject waypoint. */
  positions: Vector3fPb[];
  /** Array of velocities at each subject waypoint. */
  velocities: Vector3fPb[];
  /** Desired azimuth and range to track the subject at. */
  azimuth: number;
  range: number;
}

export interface VelocityFrame {
}

export enum VelocityFrame_Enum {
  /** NAV - Default for backwards compatibility */
  NAV = 0,
  BODY = 1,
  UNRECOGNIZED = -1,
}

export function velocityFrame_EnumFromJSON(object: any): VelocityFrame_Enum {
  switch (object) {
    case 0:
    case "NAV":
      return VelocityFrame_Enum.NAV;
    case 1:
    case "BODY":
      return VelocityFrame_Enum.BODY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return VelocityFrame_Enum.UNRECOGNIZED;
  }
}

export function velocityFrame_EnumToJSON(object: VelocityFrame_Enum): string {
  switch (object) {
    case VelocityFrame_Enum.NAV:
      return "NAV";
    case VelocityFrame_Enum.BODY:
      return "BODY";
    case VelocityFrame_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Deprecated */
export interface SetGimbalOrientationArgs {
  /** [rad] */
  gimbalPitch: number;
  /** [rad] */
  gimbalRoll: number;
}

/**
 * Command a desired velocity for some amount of time, with a given max_speed setting.
 * Several DesiredVelocity actions can be concatenated to create more complex movement.
 */
export interface TestDesiredVelocityActionArgs {
  /**
   * Movement API settings, valid for the duration of this velocity command. If none, does not
   * modify settings (settings will be reset to default values)
   */
  settings:
    | MovementApiSettings
    | undefined;
  /**
   * Desired Velocity in the specified frame (default nav)
   * If none, commands 0 velocity.
   */
  velocity:
    | Vector3fPb
    | undefined;
  /** frame of the velocity vector */
  velocityFrame: VelocityFrame_Enum;
  /** Desired heading rate */
  headingRate: number;
  /** Desired camera pitch rate */
  pitchRate: number;
  /** Duration to run this command for, in seconds */
  durationSeconds: number;
  /** Acquire this heading (in NAV) before starting the linear movement */
  headingAtStart?:
    | number
    | undefined;
  /** How long to wait until the start heading is acquired before starting linear movement */
  waitForHeading: number;
  /** Optional description of the purpose of the current action. */
  description: string;
}

/** Deprecated */
export interface TrackTrajectoryWaypoint {
  position: Vector3fPb | undefined;
  speed: number;
}

/** Deprecated */
export interface TestTrackTrajectoryActionArgs {
  /** Other Movement API settings */
  settings:
    | MovementApiSettings
    | undefined;
  /** Waypoints to track */
  waypoints: TrackTrajectoryWaypoint[];
  /** How much we try to achieve reference positions. [0-1] controls the weight of the cost */
  positionAggressiveness: number;
  /** How much we try to achieve reference velocities. [0-1] controls the weight of the cost */
  velocityAggressiveness: number;
  /** Acceleration [m/s^2] used in the trajectory's linear speed profile */
  maxAcceleration: number;
}

export interface TestTrackTrajectoryResultData {
}

export interface TestDesiredVelocityResultData {
}

export interface AtvSubjectSpoofResultData {
}

export interface SkiSubjectSpoofResultData {
}

export interface PrecomputedSubjectSpoofResultData {
}

export interface SetGimbalOrientationResultData {
}

export interface TestTrackTrajectoryActionStateData {
}

export interface TestDesiredVelocityActionStateData {
}

export interface AtvSubjectSpoofActionStateData {
}

export interface SkiSubjectSpoofActionStateData {
}

export interface PrecomputedSubjectSpoofActionStateData {
}

export interface SetGimbalOrientationActionStateData {
}

function createBaseMovementApiSettings(): MovementApiSettings {
  return { maxSpeed: 0, maxHeadingRate: 0, maxGimbalPitchRate: 0, overridePrecisionFlight: false };
}

export const MovementApiSettings = {
  encode(message: MovementApiSettings, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.maxSpeed !== 0) {
      writer.uint32(13).float(message.maxSpeed);
    }
    if (message.maxHeadingRate !== 0) {
      writer.uint32(21).float(message.maxHeadingRate);
    }
    if (message.maxGimbalPitchRate !== 0) {
      writer.uint32(29).float(message.maxGimbalPitchRate);
    }
    if (message.overridePrecisionFlight === true) {
      writer.uint32(32).bool(message.overridePrecisionFlight);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MovementApiSettings {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMovementApiSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.maxSpeed = reader.float();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.maxHeadingRate = reader.float();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.maxGimbalPitchRate = reader.float();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.overridePrecisionFlight = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MovementApiSettings {
    return {
      maxSpeed: isSet(object.maxSpeed) ? globalThis.Number(object.maxSpeed) : 0,
      maxHeadingRate: isSet(object.maxHeadingRate) ? globalThis.Number(object.maxHeadingRate) : 0,
      maxGimbalPitchRate: isSet(object.maxGimbalPitchRate) ? globalThis.Number(object.maxGimbalPitchRate) : 0,
      overridePrecisionFlight: isSet(object.overridePrecisionFlight)
        ? globalThis.Boolean(object.overridePrecisionFlight)
        : false,
    };
  },

  toJSON(message: MovementApiSettings): unknown {
    const obj: any = {};
    if (message.maxSpeed !== 0) {
      obj.maxSpeed = message.maxSpeed;
    }
    if (message.maxHeadingRate !== 0) {
      obj.maxHeadingRate = message.maxHeadingRate;
    }
    if (message.maxGimbalPitchRate !== 0) {
      obj.maxGimbalPitchRate = message.maxGimbalPitchRate;
    }
    if (message.overridePrecisionFlight === true) {
      obj.overridePrecisionFlight = message.overridePrecisionFlight;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MovementApiSettings>, I>>(base?: I): MovementApiSettings {
    return MovementApiSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MovementApiSettings>, I>>(object: I): MovementApiSettings {
    const message = createBaseMovementApiSettings();
    message.maxSpeed = object.maxSpeed ?? 0;
    message.maxHeadingRate = object.maxHeadingRate ?? 0;
    message.maxGimbalPitchRate = object.maxGimbalPitchRate ?? 0;
    message.overridePrecisionFlight = object.overridePrecisionFlight ?? false;
    return message;
  },
};

function createBaseAtvSubjectSpoofActionArgs(): AtvSubjectSpoofActionArgs {
  return {
    numLoops: 0,
    accel: 0,
    decel: 0,
    minSpeed: 0,
    maxSpeed: 0,
    length: 0,
    width: 0,
    radius: 0,
    altitudeOffset: 0,
    forward: false,
    reverse: false,
  };
}

export const AtvSubjectSpoofActionArgs = {
  encode(message: AtvSubjectSpoofActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.numLoops !== 0) {
      writer.uint32(8).int32(message.numLoops);
    }
    if (message.accel !== 0) {
      writer.uint32(21).float(message.accel);
    }
    if (message.decel !== 0) {
      writer.uint32(29).float(message.decel);
    }
    if (message.minSpeed !== 0) {
      writer.uint32(37).float(message.minSpeed);
    }
    if (message.maxSpeed !== 0) {
      writer.uint32(45).float(message.maxSpeed);
    }
    if (message.length !== 0) {
      writer.uint32(53).float(message.length);
    }
    if (message.width !== 0) {
      writer.uint32(61).float(message.width);
    }
    if (message.radius !== 0) {
      writer.uint32(69).float(message.radius);
    }
    if (message.altitudeOffset !== 0) {
      writer.uint32(77).float(message.altitudeOffset);
    }
    if (message.forward === true) {
      writer.uint32(80).bool(message.forward);
    }
    if (message.reverse === true) {
      writer.uint32(88).bool(message.reverse);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AtvSubjectSpoofActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAtvSubjectSpoofActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.numLoops = reader.int32();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.accel = reader.float();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.decel = reader.float();
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.minSpeed = reader.float();
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.maxSpeed = reader.float();
          continue;
        case 6:
          if (tag !== 53) {
            break;
          }

          message.length = reader.float();
          continue;
        case 7:
          if (tag !== 61) {
            break;
          }

          message.width = reader.float();
          continue;
        case 8:
          if (tag !== 69) {
            break;
          }

          message.radius = reader.float();
          continue;
        case 9:
          if (tag !== 77) {
            break;
          }

          message.altitudeOffset = reader.float();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.forward = reader.bool();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.reverse = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AtvSubjectSpoofActionArgs {
    return {
      numLoops: isSet(object.numLoops) ? globalThis.Number(object.numLoops) : 0,
      accel: isSet(object.accel) ? globalThis.Number(object.accel) : 0,
      decel: isSet(object.decel) ? globalThis.Number(object.decel) : 0,
      minSpeed: isSet(object.minSpeed) ? globalThis.Number(object.minSpeed) : 0,
      maxSpeed: isSet(object.maxSpeed) ? globalThis.Number(object.maxSpeed) : 0,
      length: isSet(object.length) ? globalThis.Number(object.length) : 0,
      width: isSet(object.width) ? globalThis.Number(object.width) : 0,
      radius: isSet(object.radius) ? globalThis.Number(object.radius) : 0,
      altitudeOffset: isSet(object.altitudeOffset) ? globalThis.Number(object.altitudeOffset) : 0,
      forward: isSet(object.forward) ? globalThis.Boolean(object.forward) : false,
      reverse: isSet(object.reverse) ? globalThis.Boolean(object.reverse) : false,
    };
  },

  toJSON(message: AtvSubjectSpoofActionArgs): unknown {
    const obj: any = {};
    if (message.numLoops !== 0) {
      obj.numLoops = Math.round(message.numLoops);
    }
    if (message.accel !== 0) {
      obj.accel = message.accel;
    }
    if (message.decel !== 0) {
      obj.decel = message.decel;
    }
    if (message.minSpeed !== 0) {
      obj.minSpeed = message.minSpeed;
    }
    if (message.maxSpeed !== 0) {
      obj.maxSpeed = message.maxSpeed;
    }
    if (message.length !== 0) {
      obj.length = message.length;
    }
    if (message.width !== 0) {
      obj.width = message.width;
    }
    if (message.radius !== 0) {
      obj.radius = message.radius;
    }
    if (message.altitudeOffset !== 0) {
      obj.altitudeOffset = message.altitudeOffset;
    }
    if (message.forward === true) {
      obj.forward = message.forward;
    }
    if (message.reverse === true) {
      obj.reverse = message.reverse;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AtvSubjectSpoofActionArgs>, I>>(base?: I): AtvSubjectSpoofActionArgs {
    return AtvSubjectSpoofActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AtvSubjectSpoofActionArgs>, I>>(object: I): AtvSubjectSpoofActionArgs {
    const message = createBaseAtvSubjectSpoofActionArgs();
    message.numLoops = object.numLoops ?? 0;
    message.accel = object.accel ?? 0;
    message.decel = object.decel ?? 0;
    message.minSpeed = object.minSpeed ?? 0;
    message.maxSpeed = object.maxSpeed ?? 0;
    message.length = object.length ?? 0;
    message.width = object.width ?? 0;
    message.radius = object.radius ?? 0;
    message.altitudeOffset = object.altitudeOffset ?? 0;
    message.forward = object.forward ?? false;
    message.reverse = object.reverse ?? false;
    return message;
  },
};

function createBaseSkiSubjectSpoofActionArgs(): SkiSubjectSpoofActionArgs {
  return { length: 0, numberOfTurns: 0, width: 0, slopeAngle: 0, minSpeed: 0, maxSpeed: 0, altitudeOffset: 0 };
}

export const SkiSubjectSpoofActionArgs = {
  encode(message: SkiSubjectSpoofActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.length !== 0) {
      writer.uint32(13).float(message.length);
    }
    if (message.numberOfTurns !== 0) {
      writer.uint32(16).int32(message.numberOfTurns);
    }
    if (message.width !== 0) {
      writer.uint32(29).float(message.width);
    }
    if (message.slopeAngle !== 0) {
      writer.uint32(37).float(message.slopeAngle);
    }
    if (message.minSpeed !== 0) {
      writer.uint32(45).float(message.minSpeed);
    }
    if (message.maxSpeed !== 0) {
      writer.uint32(53).float(message.maxSpeed);
    }
    if (message.altitudeOffset !== 0) {
      writer.uint32(61).float(message.altitudeOffset);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SkiSubjectSpoofActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSkiSubjectSpoofActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.length = reader.float();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.numberOfTurns = reader.int32();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.width = reader.float();
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.slopeAngle = reader.float();
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.minSpeed = reader.float();
          continue;
        case 6:
          if (tag !== 53) {
            break;
          }

          message.maxSpeed = reader.float();
          continue;
        case 7:
          if (tag !== 61) {
            break;
          }

          message.altitudeOffset = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SkiSubjectSpoofActionArgs {
    return {
      length: isSet(object.length) ? globalThis.Number(object.length) : 0,
      numberOfTurns: isSet(object.numberOfTurns) ? globalThis.Number(object.numberOfTurns) : 0,
      width: isSet(object.width) ? globalThis.Number(object.width) : 0,
      slopeAngle: isSet(object.slopeAngle) ? globalThis.Number(object.slopeAngle) : 0,
      minSpeed: isSet(object.minSpeed) ? globalThis.Number(object.minSpeed) : 0,
      maxSpeed: isSet(object.maxSpeed) ? globalThis.Number(object.maxSpeed) : 0,
      altitudeOffset: isSet(object.altitudeOffset) ? globalThis.Number(object.altitudeOffset) : 0,
    };
  },

  toJSON(message: SkiSubjectSpoofActionArgs): unknown {
    const obj: any = {};
    if (message.length !== 0) {
      obj.length = message.length;
    }
    if (message.numberOfTurns !== 0) {
      obj.numberOfTurns = Math.round(message.numberOfTurns);
    }
    if (message.width !== 0) {
      obj.width = message.width;
    }
    if (message.slopeAngle !== 0) {
      obj.slopeAngle = message.slopeAngle;
    }
    if (message.minSpeed !== 0) {
      obj.minSpeed = message.minSpeed;
    }
    if (message.maxSpeed !== 0) {
      obj.maxSpeed = message.maxSpeed;
    }
    if (message.altitudeOffset !== 0) {
      obj.altitudeOffset = message.altitudeOffset;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SkiSubjectSpoofActionArgs>, I>>(base?: I): SkiSubjectSpoofActionArgs {
    return SkiSubjectSpoofActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SkiSubjectSpoofActionArgs>, I>>(object: I): SkiSubjectSpoofActionArgs {
    const message = createBaseSkiSubjectSpoofActionArgs();
    message.length = object.length ?? 0;
    message.numberOfTurns = object.numberOfTurns ?? 0;
    message.width = object.width ?? 0;
    message.slopeAngle = object.slopeAngle ?? 0;
    message.minSpeed = object.minSpeed ?? 0;
    message.maxSpeed = object.maxSpeed ?? 0;
    message.altitudeOffset = object.altitudeOffset ?? 0;
    return message;
  },
};

function createBasePrecomputedSubjectSpoofActionArgs(): PrecomputedSubjectSpoofActionArgs {
  return { numLoops: 0, times: [], positions: [], velocities: [], azimuth: 0, range: 0 };
}

export const PrecomputedSubjectSpoofActionArgs = {
  encode(message: PrecomputedSubjectSpoofActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.numLoops !== 0) {
      writer.uint32(8).int32(message.numLoops);
    }
    writer.uint32(18).fork();
    for (const v of message.times) {
      writer.float(v);
    }
    writer.ldelim();
    for (const v of message.positions) {
      Vector3fPb.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    for (const v of message.velocities) {
      Vector3fPb.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    if (message.azimuth !== 0) {
      writer.uint32(45).float(message.azimuth);
    }
    if (message.range !== 0) {
      writer.uint32(53).float(message.range);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PrecomputedSubjectSpoofActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePrecomputedSubjectSpoofActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.numLoops = reader.int32();
          continue;
        case 2:
          if (tag === 21) {
            message.times.push(reader.float());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.times.push(reader.float());
            }

            continue;
          }

          break;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.positions.push(Vector3fPb.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.velocities.push(Vector3fPb.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.azimuth = reader.float();
          continue;
        case 6:
          if (tag !== 53) {
            break;
          }

          message.range = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PrecomputedSubjectSpoofActionArgs {
    return {
      numLoops: isSet(object.numLoops) ? globalThis.Number(object.numLoops) : 0,
      times: globalThis.Array.isArray(object?.times) ? object.times.map((e: any) => globalThis.Number(e)) : [],
      positions: globalThis.Array.isArray(object?.positions)
        ? object.positions.map((e: any) => Vector3fPb.fromJSON(e))
        : [],
      velocities: globalThis.Array.isArray(object?.velocities)
        ? object.velocities.map((e: any) => Vector3fPb.fromJSON(e))
        : [],
      azimuth: isSet(object.azimuth) ? globalThis.Number(object.azimuth) : 0,
      range: isSet(object.range) ? globalThis.Number(object.range) : 0,
    };
  },

  toJSON(message: PrecomputedSubjectSpoofActionArgs): unknown {
    const obj: any = {};
    if (message.numLoops !== 0) {
      obj.numLoops = Math.round(message.numLoops);
    }
    if (message.times?.length) {
      obj.times = message.times;
    }
    if (message.positions?.length) {
      obj.positions = message.positions.map((e) => Vector3fPb.toJSON(e));
    }
    if (message.velocities?.length) {
      obj.velocities = message.velocities.map((e) => Vector3fPb.toJSON(e));
    }
    if (message.azimuth !== 0) {
      obj.azimuth = message.azimuth;
    }
    if (message.range !== 0) {
      obj.range = message.range;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PrecomputedSubjectSpoofActionArgs>, I>>(
    base?: I,
  ): PrecomputedSubjectSpoofActionArgs {
    return PrecomputedSubjectSpoofActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PrecomputedSubjectSpoofActionArgs>, I>>(
    object: I,
  ): PrecomputedSubjectSpoofActionArgs {
    const message = createBasePrecomputedSubjectSpoofActionArgs();
    message.numLoops = object.numLoops ?? 0;
    message.times = object.times?.map((e) => e) || [];
    message.positions = object.positions?.map((e) => Vector3fPb.fromPartial(e)) || [];
    message.velocities = object.velocities?.map((e) => Vector3fPb.fromPartial(e)) || [];
    message.azimuth = object.azimuth ?? 0;
    message.range = object.range ?? 0;
    return message;
  },
};

function createBaseVelocityFrame(): VelocityFrame {
  return {};
}

export const VelocityFrame = {
  encode(_: VelocityFrame, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VelocityFrame {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVelocityFrame();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): VelocityFrame {
    return {};
  },

  toJSON(_: VelocityFrame): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<VelocityFrame>, I>>(base?: I): VelocityFrame {
    return VelocityFrame.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VelocityFrame>, I>>(_: I): VelocityFrame {
    const message = createBaseVelocityFrame();
    return message;
  },
};

function createBaseSetGimbalOrientationArgs(): SetGimbalOrientationArgs {
  return { gimbalPitch: 0, gimbalRoll: 0 };
}

export const SetGimbalOrientationArgs = {
  encode(message: SetGimbalOrientationArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.gimbalPitch !== 0) {
      writer.uint32(13).float(message.gimbalPitch);
    }
    if (message.gimbalRoll !== 0) {
      writer.uint32(21).float(message.gimbalRoll);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetGimbalOrientationArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetGimbalOrientationArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.gimbalPitch = reader.float();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.gimbalRoll = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetGimbalOrientationArgs {
    return {
      gimbalPitch: isSet(object.gimbalPitch) ? globalThis.Number(object.gimbalPitch) : 0,
      gimbalRoll: isSet(object.gimbalRoll) ? globalThis.Number(object.gimbalRoll) : 0,
    };
  },

  toJSON(message: SetGimbalOrientationArgs): unknown {
    const obj: any = {};
    if (message.gimbalPitch !== 0) {
      obj.gimbalPitch = message.gimbalPitch;
    }
    if (message.gimbalRoll !== 0) {
      obj.gimbalRoll = message.gimbalRoll;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetGimbalOrientationArgs>, I>>(base?: I): SetGimbalOrientationArgs {
    return SetGimbalOrientationArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetGimbalOrientationArgs>, I>>(object: I): SetGimbalOrientationArgs {
    const message = createBaseSetGimbalOrientationArgs();
    message.gimbalPitch = object.gimbalPitch ?? 0;
    message.gimbalRoll = object.gimbalRoll ?? 0;
    return message;
  },
};

function createBaseTestDesiredVelocityActionArgs(): TestDesiredVelocityActionArgs {
  return {
    settings: undefined,
    velocity: undefined,
    velocityFrame: 0,
    headingRate: 0,
    pitchRate: 0,
    durationSeconds: 0,
    headingAtStart: undefined,
    waitForHeading: 0,
    description: "",
  };
}

export const TestDesiredVelocityActionArgs = {
  encode(message: TestDesiredVelocityActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.settings !== undefined) {
      MovementApiSettings.encode(message.settings, writer.uint32(10).fork()).ldelim();
    }
    if (message.velocity !== undefined) {
      Vector3fPb.encode(message.velocity, writer.uint32(18).fork()).ldelim();
    }
    if (message.velocityFrame !== 0) {
      writer.uint32(64).int32(message.velocityFrame);
    }
    if (message.headingRate !== 0) {
      writer.uint32(29).float(message.headingRate);
    }
    if (message.pitchRate !== 0) {
      writer.uint32(37).float(message.pitchRate);
    }
    if (message.durationSeconds !== 0) {
      writer.uint32(45).float(message.durationSeconds);
    }
    if (message.headingAtStart !== undefined) {
      writer.uint32(53).float(message.headingAtStart);
    }
    if (message.waitForHeading !== 0) {
      writer.uint32(61).float(message.waitForHeading);
    }
    if (message.description !== "") {
      writer.uint32(74).string(message.description);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TestDesiredVelocityActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTestDesiredVelocityActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.settings = MovementApiSettings.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.velocity = Vector3fPb.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.velocityFrame = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.headingRate = reader.float();
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.pitchRate = reader.float();
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.durationSeconds = reader.float();
          continue;
        case 6:
          if (tag !== 53) {
            break;
          }

          message.headingAtStart = reader.float();
          continue;
        case 7:
          if (tag !== 61) {
            break;
          }

          message.waitForHeading = reader.float();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.description = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TestDesiredVelocityActionArgs {
    return {
      settings: isSet(object.settings) ? MovementApiSettings.fromJSON(object.settings) : undefined,
      velocity: isSet(object.velocity) ? Vector3fPb.fromJSON(object.velocity) : undefined,
      velocityFrame: isSet(object.velocityFrame) ? velocityFrame_EnumFromJSON(object.velocityFrame) : 0,
      headingRate: isSet(object.headingRate) ? globalThis.Number(object.headingRate) : 0,
      pitchRate: isSet(object.pitchRate) ? globalThis.Number(object.pitchRate) : 0,
      durationSeconds: isSet(object.durationSeconds) ? globalThis.Number(object.durationSeconds) : 0,
      headingAtStart: isSet(object.headingAtStart) ? globalThis.Number(object.headingAtStart) : undefined,
      waitForHeading: isSet(object.waitForHeading) ? globalThis.Number(object.waitForHeading) : 0,
      description: isSet(object.description) ? globalThis.String(object.description) : "",
    };
  },

  toJSON(message: TestDesiredVelocityActionArgs): unknown {
    const obj: any = {};
    if (message.settings !== undefined) {
      obj.settings = MovementApiSettings.toJSON(message.settings);
    }
    if (message.velocity !== undefined) {
      obj.velocity = Vector3fPb.toJSON(message.velocity);
    }
    if (message.velocityFrame !== 0) {
      obj.velocityFrame = velocityFrame_EnumToJSON(message.velocityFrame);
    }
    if (message.headingRate !== 0) {
      obj.headingRate = message.headingRate;
    }
    if (message.pitchRate !== 0) {
      obj.pitchRate = message.pitchRate;
    }
    if (message.durationSeconds !== 0) {
      obj.durationSeconds = message.durationSeconds;
    }
    if (message.headingAtStart !== undefined) {
      obj.headingAtStart = message.headingAtStart;
    }
    if (message.waitForHeading !== 0) {
      obj.waitForHeading = message.waitForHeading;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TestDesiredVelocityActionArgs>, I>>(base?: I): TestDesiredVelocityActionArgs {
    return TestDesiredVelocityActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TestDesiredVelocityActionArgs>, I>>(
    object: I,
  ): TestDesiredVelocityActionArgs {
    const message = createBaseTestDesiredVelocityActionArgs();
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? MovementApiSettings.fromPartial(object.settings)
      : undefined;
    message.velocity = (object.velocity !== undefined && object.velocity !== null)
      ? Vector3fPb.fromPartial(object.velocity)
      : undefined;
    message.velocityFrame = object.velocityFrame ?? 0;
    message.headingRate = object.headingRate ?? 0;
    message.pitchRate = object.pitchRate ?? 0;
    message.durationSeconds = object.durationSeconds ?? 0;
    message.headingAtStart = object.headingAtStart ?? undefined;
    message.waitForHeading = object.waitForHeading ?? 0;
    message.description = object.description ?? "";
    return message;
  },
};

function createBaseTrackTrajectoryWaypoint(): TrackTrajectoryWaypoint {
  return { position: undefined, speed: 0 };
}

export const TrackTrajectoryWaypoint = {
  encode(message: TrackTrajectoryWaypoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.position !== undefined) {
      Vector3fPb.encode(message.position, writer.uint32(10).fork()).ldelim();
    }
    if (message.speed !== 0) {
      writer.uint32(21).float(message.speed);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TrackTrajectoryWaypoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrackTrajectoryWaypoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.position = Vector3fPb.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.speed = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TrackTrajectoryWaypoint {
    return {
      position: isSet(object.position) ? Vector3fPb.fromJSON(object.position) : undefined,
      speed: isSet(object.speed) ? globalThis.Number(object.speed) : 0,
    };
  },

  toJSON(message: TrackTrajectoryWaypoint): unknown {
    const obj: any = {};
    if (message.position !== undefined) {
      obj.position = Vector3fPb.toJSON(message.position);
    }
    if (message.speed !== 0) {
      obj.speed = message.speed;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TrackTrajectoryWaypoint>, I>>(base?: I): TrackTrajectoryWaypoint {
    return TrackTrajectoryWaypoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrackTrajectoryWaypoint>, I>>(object: I): TrackTrajectoryWaypoint {
    const message = createBaseTrackTrajectoryWaypoint();
    message.position = (object.position !== undefined && object.position !== null)
      ? Vector3fPb.fromPartial(object.position)
      : undefined;
    message.speed = object.speed ?? 0;
    return message;
  },
};

function createBaseTestTrackTrajectoryActionArgs(): TestTrackTrajectoryActionArgs {
  return {
    settings: undefined,
    waypoints: [],
    positionAggressiveness: 0,
    velocityAggressiveness: 0,
    maxAcceleration: 0,
  };
}

export const TestTrackTrajectoryActionArgs = {
  encode(message: TestTrackTrajectoryActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.settings !== undefined) {
      MovementApiSettings.encode(message.settings, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.waypoints) {
      TrackTrajectoryWaypoint.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    if (message.positionAggressiveness !== 0) {
      writer.uint32(29).float(message.positionAggressiveness);
    }
    if (message.velocityAggressiveness !== 0) {
      writer.uint32(37).float(message.velocityAggressiveness);
    }
    if (message.maxAcceleration !== 0) {
      writer.uint32(45).float(message.maxAcceleration);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TestTrackTrajectoryActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTestTrackTrajectoryActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.settings = MovementApiSettings.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.waypoints.push(TrackTrajectoryWaypoint.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.positionAggressiveness = reader.float();
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.velocityAggressiveness = reader.float();
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.maxAcceleration = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TestTrackTrajectoryActionArgs {
    return {
      settings: isSet(object.settings) ? MovementApiSettings.fromJSON(object.settings) : undefined,
      waypoints: globalThis.Array.isArray(object?.waypoints)
        ? object.waypoints.map((e: any) => TrackTrajectoryWaypoint.fromJSON(e))
        : [],
      positionAggressiveness: isSet(object.positionAggressiveness)
        ? globalThis.Number(object.positionAggressiveness)
        : 0,
      velocityAggressiveness: isSet(object.velocityAggressiveness)
        ? globalThis.Number(object.velocityAggressiveness)
        : 0,
      maxAcceleration: isSet(object.maxAcceleration) ? globalThis.Number(object.maxAcceleration) : 0,
    };
  },

  toJSON(message: TestTrackTrajectoryActionArgs): unknown {
    const obj: any = {};
    if (message.settings !== undefined) {
      obj.settings = MovementApiSettings.toJSON(message.settings);
    }
    if (message.waypoints?.length) {
      obj.waypoints = message.waypoints.map((e) => TrackTrajectoryWaypoint.toJSON(e));
    }
    if (message.positionAggressiveness !== 0) {
      obj.positionAggressiveness = message.positionAggressiveness;
    }
    if (message.velocityAggressiveness !== 0) {
      obj.velocityAggressiveness = message.velocityAggressiveness;
    }
    if (message.maxAcceleration !== 0) {
      obj.maxAcceleration = message.maxAcceleration;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TestTrackTrajectoryActionArgs>, I>>(base?: I): TestTrackTrajectoryActionArgs {
    return TestTrackTrajectoryActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TestTrackTrajectoryActionArgs>, I>>(
    object: I,
  ): TestTrackTrajectoryActionArgs {
    const message = createBaseTestTrackTrajectoryActionArgs();
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? MovementApiSettings.fromPartial(object.settings)
      : undefined;
    message.waypoints = object.waypoints?.map((e) => TrackTrajectoryWaypoint.fromPartial(e)) || [];
    message.positionAggressiveness = object.positionAggressiveness ?? 0;
    message.velocityAggressiveness = object.velocityAggressiveness ?? 0;
    message.maxAcceleration = object.maxAcceleration ?? 0;
    return message;
  },
};

function createBaseTestTrackTrajectoryResultData(): TestTrackTrajectoryResultData {
  return {};
}

export const TestTrackTrajectoryResultData = {
  encode(_: TestTrackTrajectoryResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TestTrackTrajectoryResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTestTrackTrajectoryResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TestTrackTrajectoryResultData {
    return {};
  },

  toJSON(_: TestTrackTrajectoryResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TestTrackTrajectoryResultData>, I>>(base?: I): TestTrackTrajectoryResultData {
    return TestTrackTrajectoryResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TestTrackTrajectoryResultData>, I>>(_: I): TestTrackTrajectoryResultData {
    const message = createBaseTestTrackTrajectoryResultData();
    return message;
  },
};

function createBaseTestDesiredVelocityResultData(): TestDesiredVelocityResultData {
  return {};
}

export const TestDesiredVelocityResultData = {
  encode(_: TestDesiredVelocityResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TestDesiredVelocityResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTestDesiredVelocityResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TestDesiredVelocityResultData {
    return {};
  },

  toJSON(_: TestDesiredVelocityResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TestDesiredVelocityResultData>, I>>(base?: I): TestDesiredVelocityResultData {
    return TestDesiredVelocityResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TestDesiredVelocityResultData>, I>>(_: I): TestDesiredVelocityResultData {
    const message = createBaseTestDesiredVelocityResultData();
    return message;
  },
};

function createBaseAtvSubjectSpoofResultData(): AtvSubjectSpoofResultData {
  return {};
}

export const AtvSubjectSpoofResultData = {
  encode(_: AtvSubjectSpoofResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AtvSubjectSpoofResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAtvSubjectSpoofResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AtvSubjectSpoofResultData {
    return {};
  },

  toJSON(_: AtvSubjectSpoofResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AtvSubjectSpoofResultData>, I>>(base?: I): AtvSubjectSpoofResultData {
    return AtvSubjectSpoofResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AtvSubjectSpoofResultData>, I>>(_: I): AtvSubjectSpoofResultData {
    const message = createBaseAtvSubjectSpoofResultData();
    return message;
  },
};

function createBaseSkiSubjectSpoofResultData(): SkiSubjectSpoofResultData {
  return {};
}

export const SkiSubjectSpoofResultData = {
  encode(_: SkiSubjectSpoofResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SkiSubjectSpoofResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSkiSubjectSpoofResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SkiSubjectSpoofResultData {
    return {};
  },

  toJSON(_: SkiSubjectSpoofResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SkiSubjectSpoofResultData>, I>>(base?: I): SkiSubjectSpoofResultData {
    return SkiSubjectSpoofResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SkiSubjectSpoofResultData>, I>>(_: I): SkiSubjectSpoofResultData {
    const message = createBaseSkiSubjectSpoofResultData();
    return message;
  },
};

function createBasePrecomputedSubjectSpoofResultData(): PrecomputedSubjectSpoofResultData {
  return {};
}

export const PrecomputedSubjectSpoofResultData = {
  encode(_: PrecomputedSubjectSpoofResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PrecomputedSubjectSpoofResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePrecomputedSubjectSpoofResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): PrecomputedSubjectSpoofResultData {
    return {};
  },

  toJSON(_: PrecomputedSubjectSpoofResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<PrecomputedSubjectSpoofResultData>, I>>(
    base?: I,
  ): PrecomputedSubjectSpoofResultData {
    return PrecomputedSubjectSpoofResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PrecomputedSubjectSpoofResultData>, I>>(
    _: I,
  ): PrecomputedSubjectSpoofResultData {
    const message = createBasePrecomputedSubjectSpoofResultData();
    return message;
  },
};

function createBaseSetGimbalOrientationResultData(): SetGimbalOrientationResultData {
  return {};
}

export const SetGimbalOrientationResultData = {
  encode(_: SetGimbalOrientationResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetGimbalOrientationResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetGimbalOrientationResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetGimbalOrientationResultData {
    return {};
  },

  toJSON(_: SetGimbalOrientationResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetGimbalOrientationResultData>, I>>(base?: I): SetGimbalOrientationResultData {
    return SetGimbalOrientationResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetGimbalOrientationResultData>, I>>(_: I): SetGimbalOrientationResultData {
    const message = createBaseSetGimbalOrientationResultData();
    return message;
  },
};

function createBaseTestTrackTrajectoryActionStateData(): TestTrackTrajectoryActionStateData {
  return {};
}

export const TestTrackTrajectoryActionStateData = {
  encode(_: TestTrackTrajectoryActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TestTrackTrajectoryActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTestTrackTrajectoryActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TestTrackTrajectoryActionStateData {
    return {};
  },

  toJSON(_: TestTrackTrajectoryActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TestTrackTrajectoryActionStateData>, I>>(
    base?: I,
  ): TestTrackTrajectoryActionStateData {
    return TestTrackTrajectoryActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TestTrackTrajectoryActionStateData>, I>>(
    _: I,
  ): TestTrackTrajectoryActionStateData {
    const message = createBaseTestTrackTrajectoryActionStateData();
    return message;
  },
};

function createBaseTestDesiredVelocityActionStateData(): TestDesiredVelocityActionStateData {
  return {};
}

export const TestDesiredVelocityActionStateData = {
  encode(_: TestDesiredVelocityActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TestDesiredVelocityActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTestDesiredVelocityActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TestDesiredVelocityActionStateData {
    return {};
  },

  toJSON(_: TestDesiredVelocityActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TestDesiredVelocityActionStateData>, I>>(
    base?: I,
  ): TestDesiredVelocityActionStateData {
    return TestDesiredVelocityActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TestDesiredVelocityActionStateData>, I>>(
    _: I,
  ): TestDesiredVelocityActionStateData {
    const message = createBaseTestDesiredVelocityActionStateData();
    return message;
  },
};

function createBaseAtvSubjectSpoofActionStateData(): AtvSubjectSpoofActionStateData {
  return {};
}

export const AtvSubjectSpoofActionStateData = {
  encode(_: AtvSubjectSpoofActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AtvSubjectSpoofActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAtvSubjectSpoofActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AtvSubjectSpoofActionStateData {
    return {};
  },

  toJSON(_: AtvSubjectSpoofActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AtvSubjectSpoofActionStateData>, I>>(base?: I): AtvSubjectSpoofActionStateData {
    return AtvSubjectSpoofActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AtvSubjectSpoofActionStateData>, I>>(_: I): AtvSubjectSpoofActionStateData {
    const message = createBaseAtvSubjectSpoofActionStateData();
    return message;
  },
};

function createBaseSkiSubjectSpoofActionStateData(): SkiSubjectSpoofActionStateData {
  return {};
}

export const SkiSubjectSpoofActionStateData = {
  encode(_: SkiSubjectSpoofActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SkiSubjectSpoofActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSkiSubjectSpoofActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SkiSubjectSpoofActionStateData {
    return {};
  },

  toJSON(_: SkiSubjectSpoofActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SkiSubjectSpoofActionStateData>, I>>(base?: I): SkiSubjectSpoofActionStateData {
    return SkiSubjectSpoofActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SkiSubjectSpoofActionStateData>, I>>(_: I): SkiSubjectSpoofActionStateData {
    const message = createBaseSkiSubjectSpoofActionStateData();
    return message;
  },
};

function createBasePrecomputedSubjectSpoofActionStateData(): PrecomputedSubjectSpoofActionStateData {
  return {};
}

export const PrecomputedSubjectSpoofActionStateData = {
  encode(_: PrecomputedSubjectSpoofActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PrecomputedSubjectSpoofActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePrecomputedSubjectSpoofActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): PrecomputedSubjectSpoofActionStateData {
    return {};
  },

  toJSON(_: PrecomputedSubjectSpoofActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<PrecomputedSubjectSpoofActionStateData>, I>>(
    base?: I,
  ): PrecomputedSubjectSpoofActionStateData {
    return PrecomputedSubjectSpoofActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PrecomputedSubjectSpoofActionStateData>, I>>(
    _: I,
  ): PrecomputedSubjectSpoofActionStateData {
    const message = createBasePrecomputedSubjectSpoofActionStateData();
    return message;
  },
};

function createBaseSetGimbalOrientationActionStateData(): SetGimbalOrientationActionStateData {
  return {};
}

export const SetGimbalOrientationActionStateData = {
  encode(_: SetGimbalOrientationActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetGimbalOrientationActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetGimbalOrientationActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetGimbalOrientationActionStateData {
    return {};
  },

  toJSON(_: SetGimbalOrientationActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetGimbalOrientationActionStateData>, I>>(
    base?: I,
  ): SetGimbalOrientationActionStateData {
    return SetGimbalOrientationActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetGimbalOrientationActionStateData>, I>>(
    _: I,
  ): SetGimbalOrientationActionStateData {
    const message = createBaseSetGimbalOrientationActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
